import React from 'react'
import bugbounty from '../../assets/BugBountyImages/bugbounty.png'
import kalilinux from '../../assets/BugBountyImages/kalilinux.png'
import hackingscenarios from '../../assets/BugBountyImages/hackingscenarios.png'

const ZeroToHeroSection = () => {
  return (
      <div>
          <div class="container py-0 py-md-5 mt-5">


<div class="">
    <div class="d-flex  p-3">
        <div class="col-lg-6 col-12 animate-fade">
            <h1 className='text-white'>From Zero to Hero</h1>
            <h3 className='text-white'>Learn from basics to advanced Hacking</h3>

        </div>
        <div class="col-lg-4">


        </div>

    </div>


    <div class="container d-flex flex-wrap">

        <div class="col-lg-4 col-md-4 col-12 p-2 animate-fade">


            <div class="bg-theme-blue theme-border text-light rounded p-3">
                <h4>Hacking | Bug Bounty | CTF</h4>

                <p>Become a pro-hacker. Learn everything about hacking 100% practically. </p>
                <img src={bugbounty} class="w-100"></img>
            </div>

        </div>


        <div class="col-lg-4 col-md-4 col-12 p-2 animate-fade">


            <div class="bg-theme-blue theme-border text-light rounded p-3">
                <h4>Real world hacking scenarios</h4>

                <p>Cutting edge labs and tools to master hacking from basics to advanced levels </p>
                <img src={hackingscenarios} class="w-100"></img>
            </div>

        </div>



        <div class="col-lg-4 col-md-4 col-12 p-2 animate-fade">


            <div class="bg-theme-blue theme-border text-light rounded p-3">
                <h4>Master Hackers Machine with Customized Hacker's OS </h4>

                <p>Customized OS's for hackers to master hacking </p>
                <img src={kalilinux} class="w-100"></img>
            </div>

        </div>

    </div>
</div>
</div>
      
    </div>
  )
}

export default ZeroToHeroSection
